"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = exports.getNumberSuffix = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./calc"), exports);
tslib_1.__exportStar(require("./arrays"), exports);
tslib_1.__exportStar(require("./distribution"), exports);
function getNumberSuffix(num) {
    const lastDigit = (num || 0) % 10;
    switch (lastDigit) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
}
exports.getNumberSuffix = getNumberSuffix;
function format(n, digits) {
    const res = n.toString();
    if (digits && digits > res.length) {
        return res.padStart(digits, '0');
    }
    return res;
}
exports.format = format;
//# sourceMappingURL=index.js.map